import { css } from "styled-components";

export const rangeInputCss = css`
  ${({
    required,
    theme: {
      colors: { lighterGrey },
    },
  }) => `
    appearance: none;
    background-color: ${lighterGrey};
    height: 8px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    padding: 0;
    
    &::-webkit-slider-thumb {
      appearance: none;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      background-color: ${lighterGrey};
    }
    
    :disabled {
      ::-webkit-slider-thumb {
        background-color: ${lighterGrey};
      }
    }
  `}
`;

// &::-webkit-slider-thumb {
//     appearance: none;
//     height: 20px;
//     width: 20px;
//     border-radius: 50%;
//     background-color: ${p => p.theme.colors.blueGrey};
//   }
